import { colors, spacings } from "@/assets/themes";
import { Banner, Block, Body14, Carousel, H2, List } from "@/components";
import { BANNER } from "@/components/Styles/variants";
import { useAskService, useBreakpoints } from "@/modules/hooks";
import polyglot from "@/utils/polyglot";
import CategoryItem from "../Blocks/CategoryItem";

const HomeEventCategories = ({ block }) => {
  const breakpoints = useBreakpoints();

  const calculateSlidesToShow = (length) => {
    if (length <= 2) {
      return { xs: 1.5, lg: 2, xl: 2 };
    }
    if (length === 3) {
      return { xs: 1.5, lg: 3, xl: 3 };
    }
    return { xs: 1.5, lg: 3, xl: 4 };
  };

  return (
    <Block spaceY={spacings.s}>
      {breakpoints.get({ xs: true, md: false }) ? (
        <Block
          marginX={{ xs: `calc(${spacings.m} * -1)`, md: "0px" }}
          spaceY={spacings.m}
        >
          <Carousel
            slideToShow={calculateSlidesToShow(block.data?.length)}
            gutter={breakpoints.get({ xs: spacings.s, md: spacings.m })}
            paddingX={{ xs: spacings.m, md: "0px" }}
            withGutters={breakpoints.get({ xs: true, md: false })}
          >
            {block.data?.map((item, i) => (
              <CategoryItem
                {...item}
                title={item.title || polyglot.t(`categories.${item.id}.name`)}
                key={`categories-horizontal-${block.category_id}-${i}`}
              />
            ))}
          </Carousel>
        </Block>
      ) : (
        <Block
          display="grid"
          gridCols={{ xs: 1, md: 2, xl: 3 }}
          gap={{ xs: spacings.sm, md: spacings.m }}
          marginTop={{ xs: spacings.xs, md: spacings.s }}
        >
          {block.data.map((item) => (
            <CategoryItem
              key={`home-event-category-${item.id}`}
              {...item}
              title={item.title || polyglot.t(`categories.${item.id}.name`)}
            />
          ))}
        </Block>
      )}
    </Block>
  );
};

const BackToSchool = () => {
  const breakpoints = useBreakpoints();
  const askService = useAskService();

  const getMockedCategories = () => [
    {
      title: polyglot.t("back_to_school.categories.title1"),
      display: "categories",
      data: [
        {
          id: 9002,
          subtitle: polyglot.t("back_to_school.categories.subtitle1"),
        },
        {
          id: 4001,
          subtitle: polyglot.t("back_to_school.categories.subtitle2"),
        },
        {
          id: 29,
          subtitle: polyglot.t("back_to_school.categories.subtitle3"),
          onClick: () => {
            askService.show({ id: 29 });
          },
        },
        {
          id: 7015,
          subtitle: polyglot.t("back_to_school.categories.subtitle4"),
        },
        {
          id: 9003,
          subtitle: polyglot.t("back_to_school.categories.subtitle5"),
        },
        {
          id: 7020,
          subtitle: polyglot.t("back_to_school.categories.subtitle6"),
        },
      ],
    },
    {
      title: polyglot.t("back_to_school.categories.title2"),
      display: "categories",
      data: [
        {
          id: 1001,
          subtitle: polyglot.t("back_to_school.categories.subtitle8"),
        },
        {
          id: 1032,
          subtitle: polyglot.t("back_to_school.categories.subtitle9"),
        },
        {
          id: 7022,
          subtitle: polyglot.t("back_to_school.categories.subtitle10"),
        },
        {
          id: 4015,
          subtitle: polyglot.t("back_to_school.categories.subtitle11"),
        },
      ],
    },
    {
      title: polyglot.t("back_to_school.categories.title3"),
      display: "categories",
      data: [
        {
          id: 3003,
          subtitle: polyglot.t("back_to_school.categories.subtitle12"),
        },
        {
          id: 3015,
          subtitle: polyglot.t("back_to_school.categories.subtitle13"),
        },
        {
          id: 2002,
          subtitle: polyglot.t("back_to_school.categories.subtitle14"),
        },
        {
          id: 1028,
          subtitle: polyglot.t("back_to_school.categories.subtitle15"),
        },
        {
          id: 6008,
          subtitle: polyglot.t("back_to_school.categories.subtitle16"),
        },
        {
          id: 29,
          subtitle: polyglot.t("back_to_school.categories.subtitle17"),
          onClick: () => {
            askService.show({ id: 29 });
          },
        },
      ],
    },
    {
      title: polyglot.t("back_to_school.categories.title4"),
      display: "categories",
      data: [
        {
          id: 5006,
          subtitle: polyglot.t("back_to_school.categories.subtitle18"),
        },
        {
          id: 5007,
          subtitle: polyglot.t("back_to_school.categories.subtitle19"),
        },
        {
          id: 5008,
          subtitle: polyglot.t("back_to_school.categories.subtitle20"),
        },
        {
          id: 4022,
          subtitle: polyglot.t("back_to_school.categories.subtitle21"),
        },
        {
          id: 4023,
          subtitle: polyglot.t("back_to_school.categories.subtitle22"),
        },
        {
          id: 4001,
          subtitle: polyglot.t("back_to_school.categories.subtitle23"),
        },
      ],
    },
    {
      title: polyglot.t("back_to_school.categories.title5"),
      display: "categories",
      data: [
        {
          id: 401,
          title: polyglot.t("back_to_school.categories.recurring1"),
          subtitle: polyglot.t("back_to_school.categories.subtitle24"),
          onClick: () => {
            window.location.href = "/recurring_jobs/new";
          },
        },
        {
          id: 21,
          title: polyglot.t("back_to_school.categories.recurring2"),
          subtitle: polyglot.t("back_to_school.categories.subtitle25"),
          onClick: () => {
            window.location.href = "/recurring_jobs/new";
          },
        },
        {
          id: 28,
          title: polyglot.t("back_to_school.categories.recurring3"),
          subtitle: polyglot.t("back_to_school.categories.subtitle26"),
          onClick: () => {
            window.location.href = "/recurring_jobs/new";
          },
        },
        {
          id: 29,
          subtitle: polyglot.t("back_to_school.categories.subtitle27"),
          onClick: () => {
            window.location.href = "/recurring_jobs/new";
          },
        },
      ],
    },
  ];

  const data = getMockedCategories();

  return (
    <Block>
      <List.Header>
        <H2>{polyglot.t("back_to_school.title")}</H2>
      </List.Header>

      <Block
        display="flex"
        flexDirection="column"
        gap={{ xs: spacings.s, md: spacings.l }}
      >
        {data.map((block) => (
          <div key={`home-event-block-${block.title}`}>
            {block.title ? (
              <List.Header>{block.title}</List.Header>
            ) : (
              <Block marginTop={spacings.l} />
            )}
            {block.display === "banner_vertical" &&
              block.data.map((item) => (
                <Banner
                  {...rawBanners[item]}
                  size={breakpoints.get({
                    xs: BANNER.SIZE.MEDIUM,
                    xl: BANNER.SIZE.LARGE,
                  })}
                  key={`home-event-banner-${item}`}
                />
              ))}
            {block.display === "categories" && (
              <HomeEventCategories block={block} />
            )}
          </div>
        ))}
      </Block>
    </Block>
  );
};

export default BackToSchool;
